import React from 'react';
import { Button, Modal } from 'rsuite';
import styles from './ModalLayout.module.scss';

type ConfirmModalProps = {
  show: boolean;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  onCancel: () => void;
  cancelButton?: string;
  onConfirm?: () => void;
  confirmButton?: string;
  confirmDisabled?: boolean;
  width?: string | number;
  height?: string | number;
};

export const ModalLayout: React.FC<ConfirmModalProps> = ({
  show,
  title,
  subtitle,
  children,
  onCancel,
  cancelButton,
  onConfirm,
  confirmButton,
  confirmDisabled,
  width,
  height,
}) => (
  <Modal backdrop show={show} className={styles.modalRoot} style={{ width, height }} onHide={onCancel}>
    <Modal.Header>
      <Modal.Title className={styles.title}>{title}</Modal.Title>
      {subtitle ? <Modal.Title className={styles.subtitle}>{subtitle}</Modal.Title> : null}
    </Modal.Header>
    <Modal.Body>{children}</Modal.Body>
    <Modal.Footer>
      {cancelButton ? (
        <Button onClick={onCancel} appearance={confirmButton ? 'ghost' : 'primary'} size="lg">
          {cancelButton}
        </Button>
      ) : null}
      {confirmButton ? (
        <Button onClick={onConfirm} appearance="primary" size="lg" disabled={confirmDisabled}>
          {confirmButton}
        </Button>
      ) : null}
    </Modal.Footer>
  </Modal>
);
